import React from "react";
export const DATA_EMAIL = [
	{ keyText: "OEM · ODM 문의", valueText: "oem.odm@donggubat.com" },

	{ keyText: "사입 · 위탁 · 단체주문 문의", valueText: "brandsales@donggubat.com" },

	{ keyText: "마케팅 · 비즈니스 제휴 문의", valueText: "brandcommunication@donggubat.com" },

	{ keyText: "고객 CS 문의", valueText: "cs@donggubat.com" },
];
const ContactEmail = () => {
	return (
		<div className={"ContactEmail"}>
			<ul className="email-wrapper">
				{DATA_EMAIL.map((email, index) => {
					return (
						<li className="email-list" key={index}>
							<p className="text-key">{email.keyText}</p>
							<p className="text-value">
								<a href={`mailto:${email.valueText}`}>{email.valueText}</a>
							</p>
						</li>
					);
				})}
			</ul>
		</div>
	);
};

export default ContactEmail;
